import AssemblyVsNectar from "../../components/compare/AssemblyVsNectar";

export { Page }

function Page() {
  return <AssemblyVsNectar />;
}